import { Asset, Entry, ProgramContent } from '@cibo/core'

interface ProgramIconProps {
  program: { content: Entry<ProgramContent> }
  size?: number
}

export const ProgramIcon = ({ program, size = 50 }: ProgramIconProps) => {
  const logoFields = (program.content.fields.logo as Asset)?.fields
  return (
    <img
      style={{ height: `${size}px`, width: `${size}px`, objectFit: 'contain' }}
      src={`${logoFields?.file?.url}`}
      srcSet={`${logoFields?.file?.url}?w=${size}, ${logoFields?.file?.url}?w=${size * 2} 2x, ${
        logoFields?.file?.url
      }?w=${size * 3} 3x`}
      alt={logoFields?.description || ''}
      loading="lazy"
      data-testid="programIcon"
    />
  )
}
